import { render } from "./NoData.vue?vue&type=template&id=3369c00d"
import script from "./NoData.vue?vue&type=script&lang=js"
export * from "./NoData.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/provider-frontend/provider-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__